/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import * as Urql from 'urql';

import type * as Types from '../../../../../../../generated/graphql/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetCustomerProfileQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetCustomerProfileQuery = { __typename?: 'Query' } & {
  customer: Types.Maybe<
    { __typename?: 'Customer' } & Pick<
      Types.Customer,
      | 'id'
      | 'uuid'
      | 'username'
      | 'firstName'
      | 'lastName'
      | 'email'
      | 'phone'
      | 'profileImage'
      | 'platform'
      | 'language'
      | 'timeZone'
      | 'fiscalNumber'
      | 'createdAt'
      | 'updatedAt'
      | 'socialAuthGoogleId'
      | 'socialAuthFacebookId'
      | 'receiveOffers'
      | 'receiveSmsOffers'
      | 'refererId'
      | 'isGuest'
      | 'market'
    >
  >;
};

export const GetCustomerProfileDocument = /*#__PURE__*/ `
    query GetCustomerProfile {
  customer {
    id
    uuid
    username
    firstName
    lastName
    email
    phone
    profileImage
    platform
    language
    timeZone
    fiscalNumber
    createdAt
    updatedAt
    socialAuthGoogleId
    socialAuthFacebookId
    receiveOffers
    receiveSmsOffers
    refererId
    isGuest
    market
  }
}
    `;

export function useGetCustomerProfileQuery(
  options?: Omit<Urql.UseQueryArgs<GetCustomerProfileQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    GetCustomerProfileQuery,
    GetCustomerProfileQueryVariables
  >({ query: GetCustomerProfileDocument, ...options });
}
